import React from 'react';
import clsx from 'clsx';
import * as styles from './style.module.css';
import ExternalLinkIcon12 from './ExternalLinkIcon12';
import Depot from '../_shared/depot';
export const LinkComponent = ({ external = false, inherit = false, icon: Icon, label, variant = 'blue', children, className, ...commonProps }) => {
    // Classes
    const classes = clsx(className, styles.root, {
        [styles.inherit]: inherit || variant === 'inherit',
    });
    const iconClasses = clsx(styles.interfaceIcon);
    return Depot.createElement('a', {
        target: external || variant === 'external' ? '_blank' : undefined,
        ...commonProps,
        className: classes,
    }, React.createElement(React.Fragment, null,
        (Icon || (variant === 'icon' && Icon)) && (React.createElement(Icon, { className: iconClasses, size: 24 })),
        label || children,
        (external || variant === 'external') && React.createElement(ExternalLinkIcon12, null)));
};
const Link = Depot.withRef(LinkComponent);
Link.displayName = 'Link';
export default Link;
//# sourceMappingURL=index.js.map